// src/components/pages/watch/SeriesPage.js

import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Button,
} from "@mui/material";
import { NAVBAR_HEIGHT } from "../../../constants/constants";

// Placeholder for a featured episode
const FEATURED_EPISODE = {
  id: 999,
  title: "Episode 1: Interview with actor & director Jordan Peele",
  image:
    "https://s.yimg.com/ny/api/res/1.2/lmr.CD06779o5.C2CjeYzA--/YXBwaWQ9aGlnaGxhbmRlcjt3PTk2MDtoPTU0MA--/https://media.zenfs.com/en/cinemablend_388/08b1794447835512ce2ba1aaef3529d9",
  description:
    "Join us for an in-depth conversation with Jordan Peele about his latest film and creative process.",
};

// Placeholder episodes for this series
const EPISODES = [
  {
    id: 1,
    title: "Episode 2: Comedy Roundtable",
    image:
      "https://ca-times.brightspotcdn.com/dims4/default/7ef501e/2147483647/strip/true/crop/3840x2160+0+0/resize/1200x675!/quality/75/?url=https%3A%2F%2Fcalifornia-times-brightspot.s3.amazonaws.com%2F34%2F40%2Fac1c799f46c49f09f22ebabae5b7%2Femmys23-comedy-supercut-promo-thumbnail.jpg",
    description:
      "A hilarious discussion with top comedians as they share behind-the-scenes stories, their favorite jokes, and the art of making people laugh.",
  },
  {
    id: 2,
    title: "Episode 3: Live from Denver Zoo",
    image:
      "https://images.axios.com/1B43SioavmmEo0M6awMc-xscp1s=/0x69:6048x3471/1920x1080/2024/05/23/1716497096255.jpg",
    description:
      "Experience the wild side as we go live from the Denver Zoo, featuring interviews with zookeepers and a look at some amazing animal encounters.",
  },
  {
    id: 3,
    title: "Episode 4: Cooking with Chefs",
    image: "https://images.cdn.edx.org/post946-Cooking.jpg",
    description:
      "Join top chefs in the kitchen as they share their favorite recipes, cooking techniques, and the stories behind their culinary inspirations.",
  },
];

const SeriesPage = () => {
  const { id } = useParams(); // the :id from the URL
  const navigate = useNavigate();

  // In a real app, you might fetch series details by ID here

  // Handle click on an episode card
  const handleEpisodeClick = (episodeId) => {
    // Navigate to the video player page
    navigate(`/video/${episodeId}`);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: `calc(100vh - ${NAVBAR_HEIGHT}px)`,
        bgcolor: "#f9f9f9",
      }}
    >
      {/* Featured episode section */}
      <Box
        sx={{ px: 2, pb: 4, mt: 3, width: "95%", maxWidth: 800, mx: "auto" }}
      >
        <Card
          key={1}
          onClick={() => handleEpisodeClick(FEATURED_EPISODE.id)}
          elevation={0}
          sx={{
            cursor: "pointer",
            borderRadius: 1,
            backgroundColor: "transparent",
          }}
        >
          <CardMedia
            component="img"
            image={FEATURED_EPISODE.image}
            alt={FEATURED_EPISODE.title}
            sx={{
              width: "100%",
              aspectRatio: "16/9",
              objectFit: "cover",
              borderRadius: 1,
            }}
          />
          <CardContent>
            <Typography variant="subtitle1" fontWeight="bold">
              {FEATURED_EPISODE.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {FEATURED_EPISODE.description}
            </Typography>
          </CardContent>
        </Card>
      </Box>

      <Box
        sx={{
          px: 2,
          pb: 4,
          pt: 1,
          width: "95%",
          maxWidth: 800,
          mx: "auto",
          backgroundColor: "white",
        }}
      >
        <Typography variant="h6" sx={{ mb: 1 }}>
          More Episodes
        </Typography>
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          {EPISODES.map((ep) => (
            <Card
              key={ep.id}
              onClick={() => handleEpisodeClick(ep.id)}
              elevation={0}
              sx={{
                cursor: "pointer",
                borderRadius: 1,
                backgroundColor: "transparent",
              }}
            >
              <CardMedia
                component="img"
                image={ep.image}
                alt={ep.title}
                sx={{
                  width: "100%",
                  aspectRatio: "16/9",
                  objectFit: "cover",
                  borderRadius: 1,
                }}
              />
              <CardContent>
                <Typography variant="subtitle1" fontWeight="bold">
                  {ep.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {ep.description}
                </Typography>
              </CardContent>
            </Card>
          ))}
          <Button
            variant="contained"
            onClick={() => navigate("/watch")}
            sx={(theme) => ({
              backgroundColor: theme.colors.blue,
              color: theme.colors.white,
              borderRadius: "50px",
              padding: "14px 40px",
              marginBottom: "10px",
              fontWeight: "bold",
              fontSize: "1rem",
              textTransform: "none",
              boxShadow: "none",
              "&:hover": {
                boxShadow: "none",
              },
            })}
          >
            Watch More
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SeriesPage;
